import { Download, FileAudio } from "lucide-react";
import { VERSIONS, audioUrl, sourceUrl } from "@/lib/enhanceApi";

const safe = (t) => (t || "vocal").replace(/[^\w\s()-]+/g, "").trim().slice(0, 80) || "vocal";
const pill = "inline-flex items-center gap-1.5 rounded-full border border-white/12 bg-white/[0.05] px-3 py-1.5 text-[12px] font-medium text-white/80 transition-colors hover:bg-white/[0.12] hover:text-white";

/** WAV (24-bit, 48 kHz — Studio One ready) or MP3 (320 kbps) of each version, plus the file you uploaded. */
export default function DownloadPanel({ item }) {
  return (
    <section data-testid="download-panel" className="rounded-3xl border border-white/[0.08] bg-[#0a0d1c]/80 p-5 sm:p-6">
      <h2 className="flex items-center gap-2 font-display text-base font-semibold md:text-lg"><Download className="h-4 w-4 text-white/60" /> Download</h2>
      <div className="mt-3 divide-y divide-white/[0.06]">
        {VERSIONS.filter((v) => item.versions?.[v.key]).map((v) => (
          <div key={v.key} className="flex flex-wrap items-center justify-between gap-2 py-2.5">
            <span className="flex items-center gap-2 text-[13px]"><span className="h-2.5 w-2.5 rounded-full" style={{ background: v.color }} />{v.label}</span>
            <span className="flex gap-2">
              <a className={pill} data-testid={`download-${v.key}-wav`} href={audioUrl(item, v.key, "wav")} download={`${safe(item.title)} - ${v.label}.wav`}>WAV 24-bit</a>
              <a className={pill} data-testid={`download-${v.key}-mp3`} href={audioUrl(item, v.key, "mp3")} download={`${safe(item.title)} - ${v.label}.mp3`}>MP3</a>
            </span>
          </div>
        ))}
        <div className="flex items-center justify-between gap-2 py-2.5">
          <span className="flex items-center gap-2 text-[13px] text-white/60"><FileAudio className="h-3.5 w-3.5" /> The file you uploaded</span>
          <a className={pill} data-testid="download-source" href={sourceUrl(item)} download={item.filename}>{(item.ext || "file").toUpperCase()}</a>
        </div>
      </div>
    </section>
  );
}
